export { default as RelatedPosts } from './related-posts';
